import ja from "date-fns/locale/ja";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import { Controller, get, useWatch } from "react-hook-form";

import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

/**
 * テキストフィールド基本コンポーネント
 */

registerLocale("ja", ja);

export default function FormDatePicker(props: {
  // タイトル
  subject?: string;
  // name属性
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // クラス名
  className?: string;
  // フォームコントロール
  control: any;
  // 日付フォーマット
  dateFormat?: any;
  // エラー情報
  errors: any;
  // 開始日
  startDate?: Date;
  // 終了日
  endDate?: Date;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const value = useWatch({
    control: props.control,
    name: props.name,
  });

  useEffect(() => {
    console.debug("datevalue", value);
  }, [value]);
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */

  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        defaultValue={""}
        rules={
          props.required
            ? {
                required: "必須項目です。",
              }
            : {}
        }
        render={({ field }) => {
          return (
            <>
              {props.subject && (
                <label htmlFor="descriptionHtml" className="form-label">
                  {props.subject}
                </label>
              )}
              <ReactDatePicker
                locale={ja}
                className={`form-control ${props.className}`}
                placeholderText={props.placeholder}
                selected={value}
                onChange={field.onChange}
                dateFormat={props.dateFormat || "YYYY/MM/dd"}
                selectsStart
                startDate={props.startDate}
                selectsEnd
                endDate={props.endDate}
              />
              {get(props.errors, props.name) && (
                <p className="error">
                  {get(props.errors, props.name)?.message}
                </p>
              )}
            </>
          );
        }}
      />
    </>
  );
}
